import {
  ConfirmationNumber,
  Gite,
  LocationSearchingSharp,
  Masks,
  MedicalServices,
} from '@mui/icons-material';
import { Box, Stack } from '@mui/material';
import { themeColors } from 'Global/JsxThemeColor/JsxThemeColor';
import React from 'react';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';

const TurnDetails = ({ turn, showDetails }) => {
  return (
    <React.Fragment>
      <Stack
        sx={{
          height: showDetails ? '100%' : 0,
          display: !showDetails ? 'none' : '',
        }}
        gap="1em"
      >
        <Stack direction="row-reverse" gap="1em">
          <MedicalServices
            sx={{
              fill: `${themeColors.ColorPrimary} !important`,
            }}
          />
          <p>{ArabicToPersian(turn?.ServiceNameBarname)}</p>
        </Stack>
        {turn?.DoctorName ? (
          <Stack direction="row-reverse" gap="1em">
            <Gite
              sx={{
                fill: `${themeColors.ColorPrimary} !important`,
              }}
            />
            <p>{ArabicToPersian(turn?.HospitallName)}</p>
          </Stack>
        ) : (
          <></>
        )}

        {/* <Stack direction="row-reverse" gap="1em">
          <Masks color="info" />
          <p>{ArabicToPersian(turn?.DoctorName)}</p>
        </Stack> */}
        <Stack direction="row-reverse" gap="1em">
          <ConfirmationNumber
            sx={{
              fill: `${themeColors.ColorPrimary} !important`,
            }}
          />
          <p>{turn?.NobatNO}</p>
        </Stack>
        <Stack direction="row-reverse" gap="1em">
          <LocationSearchingSharp
            sx={{
              fill: `${themeColors.ColorPrimary} !important`,
            }}
          />
          <p>{turn?.PaygiriNo}</p>
        </Stack>
      </Stack>
    </React.Fragment>
  );
};

export default TurnDetails;
